export const PROFILE_IDS_PARAM = "profileIds";
export const ACTIVITY_ID_PARAM = "activityId";
